import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const NumberListIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NumberList",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.42 25.93c0-.5-.4-.9-.9-.9H3.81v-1.81h2.71c.5 0 .9-.4.9-.9v-3.61c0-.5-.4-.9-.9-.9H2.91c-.5 0-.9.4-.9.9s.4.9.9.9h2.71v1.81H2.91c-.5 0-.9.4-.9.9v3.61c0 .5.4.9.9.9h3.61c.5 0 .9-.4.9-.9M4.7 6.97h.9v6.32c0 .5.4.9.9.9s.9-.4.9-.9V6.07c0-.5-.4-.9-.9-.9H4.69c-.5 0-.9.4-.9.9s.4.9.9.9Zm23.95-.9H12.39c-.75 0-1.35.61-1.35 1.35s.61 1.35 1.35 1.35h16.25c.75 0 1.35-.61 1.35-1.35s-.61-1.35-1.35-1.35ZM12.4 13.29h9.03c.75 0 1.35-.61 1.35-1.35s-.61-1.35-1.35-1.35H12.4c-.75 0-1.35.61-1.35 1.35s.61 1.35 1.35 1.35m9.03 12.64c.75 0 1.35-.61 1.35-1.35s-.61-1.35-1.35-1.35H12.4c-.75 0-1.35.61-1.35 1.35s.61 1.35 1.35 1.35zm7.22-7.22H12.39c-.75 0-1.35.61-1.35 1.35s.61 1.35 1.35 1.35h16.25c.75 0 1.35-.61 1.35-1.35s-.61-1.35-1.35-1.35Z"
    })
  }));
};